export default __webpack_public_path__ + "static/footer-deco-501d4f5e2bf121763c5e0a2a0bcb2411.png";